import { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router";

import { SiteItem } from "@vviinn/user-managment-client-ts";

import { fetchSiteDetails, useAppSelector } from "../../store";
import { fetchCustomFields } from "../../store/features/site/customFields";
import { useRequestHandlers } from "./useRequestHandlers";
import { CompanyAndSiteIds } from "../../routes/types";
import { fetchCampaignsFilters } from "../../store/features/campaigns/fetch";

export const useSiteDetails = () => {
  const { companyId, siteId } = useOutletContext<CompanyAndSiteIds>();
  const handlerParams = useRequestHandlers();
  const { getApi, dispatch } = handlerParams;
  const defaultFilters = useAppSelector((state) => state.campaigns.filters);

  const [siteDetails, setSiteDetails] = useState<SiteItem>();

  const getSiteDetails = useCallback(async () => {
    const api = await getApi();
    dispatch(fetchCustomFields({ api, value: { companyId, siteId } }));
    const details = await dispatch(
      fetchSiteDetails({
        api,
        value: { companyId, siteId },
      }),
    );
    setSiteDetails(details.payload as SiteItem);
  }, [getApi, dispatch, siteId]); //if companyId changed - siteId will also change

  useEffect(() => {
    getSiteDetails();
  }, [getSiteDetails]);

  const loadFilters = useCallback(async () => {
    if (defaultFilters.length) return;
    const api = await getApi();
    dispatch(fetchCampaignsFilters(api));
  }, [siteId, getApi, dispatch, defaultFilters.length]); //if companyId changed - siteId will also change

  useEffect(() => {
    loadFilters();
  }, [loadFilters]);

  return { siteDetails, setSiteDetails };
};
